import { cardItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          精选合集
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          按主题分类的高质量电影推荐 · 持续更新
        </p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group cursor-pointer rounded-xl bg-background-100 border border-background-200/70 overflow-hidden transition-all hover:border-primary-200"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-[11px] font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}